import { useMemo, FunctionComponent } from "react";
import { useEvent } from "@app/hooks/useEvent";
import { ReactTags, Tag } from "react-tag-autocomplete";
import "./TagInput.css";

export type TagInputProps = {
  items: string[];
  autocomplete: string[];
  /** Omitted for a guest: the tags are then shown, not editable. */
  onChange?: (tags: string[]) => void;
};

export const TagInput: FunctionComponent<TagInputProps> = ({
  items,
  autocomplete,
  onChange,
}) => {
  const tags = useMemo(
    () => items.map<Tag>((x) => ({ label: x, value: x })),
    [items]
  );

  const suggestions = useMemo(
    () => autocomplete.map<Tag>((x) => ({ label: x, value: x })),
    [autocomplete]
  );

  const handleDelete = useEvent((index: number) => {
    onChange?.(tags.filter((_, i) => i !== index).map((x) => x.label));
  });

  const handleAdd = useEvent((newTag: Tag) => {
    onChange?.([...tags, newTag].map((x) => x.label));
  });

  return (
    <ReactTags
      labelText="Tags"
      placeholderText={onChange ? "Add a tag" : ""}
      selected={tags}
      allowNew={!!onChange}
      suggestions={suggestions}
      isDisabled={!onChange}
      onAdd={handleAdd}
      onDelete={handleDelete}
      noOptionsText="No matching tags"
      collapseOnSelect={true}
    />
  );
};
